import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getPayrolls(params: any): AxiosPromise {
    return EndPointService.get('/payrolls', { params });
}

function getPayroll(id: number | string): AxiosPromise {
    return EndPointService.get(`/payrolls/${id}`);
}

function getProvidersPayrolls(data: { dateFrom: string; dateTo: string; page: number }): AxiosPromise {
    return EndPointService.get(`/payrolls/providers`, { params: data });
}

function deletePayroll(id: number | string): AxiosPromise {
    return EndPointService.delete(`/payrolls/${id}`);
}

function createPayroll(payload: any): AxiosPromise {
    return EndPointService.post('/payrolls', {}, { params: payload });
}

function updatePayroll(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/payrolls/${id}`, { ...payload });
}
function updatePayrollStatus(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/payrolls/status/paid/${id}`, { ...payload });
}
function getPayrollsEntities(id: number | string, payload: any, caseEnt: string): AxiosPromise {
    return EndPointService.get(`/${caseEnt}`, { params: { 'payroll.id': id } });
}

export default {
    getPayrolls,
    getPayrollsEntities,
    getProvidersPayrolls,
    getPayroll,
    deletePayroll,
    createPayroll,
    updatePayroll,
    updatePayrollStatus,
};
